import {APP_INITIALIZER, NgModule} from '@angular/core';
import {DatePipe, CommonModule } from '@angular/common';
import {BrowserModule, HammerModule} from '@angular/platform-browser';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {Globals} from './globals';
import {AuthGuard} from './modules/auth/helpers/authguard';
import {AuthInterceptor} from './modules/auth/helpers/authinterceptor';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {LoginPageModule} from './modules/auth/login-page/login-page.module';
import {TokenHandlerModule} from './token.ignore/token-handler/token-handler.module';
import {CheckInModule} from './modules/check-in/check-in.module';
import {BlankWorkSpaceModule} from './modules/blank-work-space/blank-work-space.module';
import {SchedulingModule} from './modules/scheduling/scheduling.module';
import {PatientModule} from './modules/patient/patient.module';
import {InsuranceModule} from './modules/insurance/insurance.module';
import {ARModule} from './modules/ar/ar.module';
import {PatientLoginModule} from './modules/auth/patientLogin/patientLogin.module';
import {NoteExampleModule} from './modules/notes/note-example/note-examplemodule';
import {LandingModule} from './landing/landing.module';
import {eRxModule} from './modules/erx/erx.module';
import {NotificationModule} from './modules/notifications/notifications.module';
import {LiveChatModule} from './modules/live-chat/live-chat.module';
import {ChartingModule} from './modules/charting/charting.module';
import {PerioModule} from './modules/perio/perio.module';
import {DirectivesModule} from './directives/directives.module';
import {ToothPickerModule} from './modules/tdo-shared/tooth-picker/tooth-picker.module';
import {ToothService} from './services/tooth.service';
import {FormsFormModule} from './modules/forms/forms-form/forms-form.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {DuplicatePatientFoundDialogComponent} from './dialog/duplicate-patient-found-dialog/duplicate-patient-found-dialog.component';
import {TdoControlsModule} from './tdo-controls/tdo-controls.module';
import {MatIconModule} from '@angular/material/icon';
import {TdoHeaderModule} from './main-interface/tdo-header/tdo-header.module';
import {MainInterfaceModule} from './main-interface/main-interface.module';
import {OfficeCommunicationModule} from './main-interface/office-communication/office-communication.module';
import {ReportsModule} from './modules/reports/reports.module';
import {MatRadioModule} from '@angular/material/radio';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {TreatmentModule} from './modules/treatment/treatment.module';
import {PrePostOpImportDialogComponent} from './dialog/pre-post-op-import-dialog/pre-post-op-import-dialog.component';
import {ImagingModule} from './modules/imaging/imaging.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import {MatListModule} from '@angular/material/list';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatOptionModule} from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {MedicalHistoryComponent} from './modules/medical-history/medical-history.component';
import {NewPainComponent} from './modules/pain/new-pain/new-pain.component';
import {MatCardModule} from '@angular/material/card';
import {MatInputModule} from '@angular/material/input';
import {TdoButtonComponent} from './tdo-controls/common/tdo-button/tdo-button/tdo-button.component';
import {NotificationCreateDialogComponent} from './dialog/notifications/notification-create-dialog/notification-create-dialog.component';
import {ProcedureSelectionDialogComponent} from './dialog/procedure-selection-dialog/procedure-selection-dialog.component';
import {NotificationToFrontItemsNeededDialogComponent} from './dialog/notifications/notification-to-front-create-dialog/dialog/notification-to-front-items-needed-dialog/notification-to-front-items-needed-dialog.component';
import {LettersSelectionDialogComponent} from './dialog/letters-selection-dialog/letters-selection-dialog.component';
import {TaskManagementDialogComponent} from './dialog/tasks/task-management-dialog/task-management-dialog.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {TaskDetailDialogComponent} from './dialog/tasks/task-detail-dialog/task-detail-dialog.component';
import {FinalReportModule} from './modules/forms/custom/final-report/final-report.module';
import {RecallComponent} from './modules/recall/recall.component';
import {MatTabsModule} from '@angular/material/tabs';
import {MatButtonModule} from '@angular/material/button';
import {RecallPrintModalComponent} from './modules/recall/recall-print-modal/recall-print-modal.component';
import {PipeModule} from './pipes/pipe.module';
import {TdoMultiselectDropdownModule} from './tdo-controls/common/tdo-multiselect-dropdown/tdo-multiselect-dropdown.module';
import {TaskUserGroupSelectionDialogComponent} from './dialog/tasks/task-user-group-selection-dialog/task-user-group-selection-dialog.component';
import {TaskUserSelectionDialogComponent} from './dialog/tasks/task-user-selection-dialog/task-user-selection-dialog.component';
import {NotificationToFrontCreateDialogComponent} from './dialog/notifications/notification-to-front-create-dialog/notification-to-front-create-dialog.component';
import {ImagePickerDialogComponent} from './dialog/image-picker-dialog/image-picker-dialog.component';
import {UploadDialogComponent} from './dialog/upload-dialog/upload-dialog.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {AccessDeniedComponent} from './modules/auth/access-denied/access-denied.component';
import {PatientCheckinDialogComponent} from './dialog/patient-checkin-dialog/patient-checkin-dialog.component';
import {PatientCheckinUploadDialogComponent} from './dialog/patient-checkin-upload-dialog/patient-checkin-upload-dialog.component';
import {DocumentDisplayDialogComponent} from './dialog/document-display-dialog/document-display-dialog.component';
import {InternalMessagingDialogComponent} from './dialog/notifications/internal-messaging-dialog/internal-messaging-dialog.component';
import {InternalMessagingPersonSelectDialogComponent} from './dialog/notifications/internal-messaging-person-select-dialog/internal-messaging-person-select-dialog.component';
import {TdoToothSelectorDialogComponent} from './dialog/tdo-tooth-selector-dialog/tdo-tooth-selector-dialog.component';
import {LettersRecipientsDialogComponent} from './dialog/letters-recipients-dialog/letters-recipients-dialog.component';
import {LettersDeliveryOptionsDialogComponent} from './dialog/letters-delivery-options-dialog/letters-delivery-options-dialog.component';
import {MtiModule} from './modules/forms/custom/mti/mti.module';
import { EditEnumDialogComponent } from './dialog/edit-enum-dialog/edit-enum-dialog.component';
import { PainHistoryDialogComponent } from './dialog/pain-history-dialog/pain-history-dialog.component';
import { MedicalHistoryDialogComponent } from './dialog/medical-history-dialog/medical-history-dialog.component';
import { PainHistoryComponent } from './modules/pain-history/pain-history.component';
import { PainHistorySleuthWizardDialogComponent } from './modules/pain-history/dialogs/pain-history-sleuth-wizard-dialog/pain-history-sleuth-wizard-dialog.component';
import { MedicalInformationAppointmentDialogComponent } from './dialog/medical-information-appointment-dialog/medical-information-appointment-dialog.component';
import {AppInitService} from './modules/auth/services/app-init.service';
import { appInitializer } from './modules/auth/helpers/app-initializer';
import { PatientHaltDialogComponent } from './dialog/patient-halt-dialog/patient-halt-dialog.component';
import { CaseEditDialogComponent } from './dialog/case-edit-dialog/case-edit-dialog.component';
import { AllPatientAppointmentsDialogComponent } from './dialog/all-patient-appointments-dialog/all-patient-appointments-dialog.component';
import { PatientAppointmentDetailDialogComponent } from './dialog/patient-appointment-detail-dialog/patient-appointment-detail-dialog.component';
import { ConfirmExplanationDialogComponent } from './dialog/confirm-explanation-dialog/confirm-explanation-dialog.component';
import { ProcedureFormMismatchDialogComponent } from './dialog/procedure-form-mismatch-dialog/procedure-form-mismatch-dialog.component';

import { FancyPhonePipe, FormatPhoneNumberPipe, FormatPhonePipe } from './pipes/format-phone.pipe';
import { ReferralPortalComponent } from './modules/referral-manager/referral-portal/referral-portal.component';
import { FolderSelectionDialogComponent } from './dialog/folder-selection-dialog/folder-selection-dialog.component';
import {MatTreeModule} from '@angular/material/tree';
import { ReferralMatchListComponent } from './modules/referral-manager/referral-match-list/referral-match-list.component';
import { PatientPortalModule } from './modules/patient-portal/patient-portal.module';
import { SaveLibLecDialogComponent } from './dialog/save-lib-lec-dialog/save-lib-lec-dialog.component';
import { ReferrerPortalModule } from './modules/referrer-portal/referrer-portal.module';
import { ReferrerLoginModule } from './modules/auth/referrerPortal/referrer-login.module';
import { ToastrModule, ToastNoAnimationModule } from 'ngx-toastr';
import { TDOTaskListService } from './main-interface/controls/tdo-task-list/tdo-task-list.service';
import { ItemFilterPipe } from './pipes/item-filter.pipe';

import { TdoSchedulerComponent } from './modules/scheduler/tdo-scheduler/tdo-scheduler.component';
import {DevExtremeModule, DxDateBoxModule, DxSchedulerModule} from "devextreme-angular";

import { TdoPaymentModule } from '@tdo-inc/tdo-payment';
import { SecureImagePipe } from './pipes/secure-image.pipe';
import {
  EditAppointmentDialogComponent
} from "./modules/scheduler/edit-appointment-dialog/edit-appointment-dialog.component";
import {MatChipsModule} from "@angular/material/chips";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {MatMenuModule} from "@angular/material/menu";
import {
  EditAppointmentSelectProcedureDialogComponent
} from "./modules/scheduler/edit-appointment-select-procedure-dialog/edit-appointment-select-procedure-dialog.component";

@NgModule({
    declarations: [
        AppComponent,
        DuplicatePatientFoundDialogComponent,
        PrePostOpImportDialogComponent,
        NotificationCreateDialogComponent,
        ProcedureSelectionDialogComponent,
        NotificationToFrontCreateDialogComponent,
        NotificationToFrontItemsNeededDialogComponent,
        LettersSelectionDialogComponent,
        TaskManagementDialogComponent,
        TaskDetailDialogComponent,
        MedicalHistoryComponent,
        NewPainComponent,
        TdoButtonComponent,
        RecallComponent,
        RecallPrintModalComponent,
        TaskUserGroupSelectionDialogComponent,
        TaskUserSelectionDialogComponent,
        ImagePickerDialogComponent,
        UploadDialogComponent,
        AccessDeniedComponent,
        PatientCheckinDialogComponent,
        PatientCheckinUploadDialogComponent,
        DocumentDisplayDialogComponent,
        InternalMessagingDialogComponent,
        InternalMessagingPersonSelectDialogComponent,
        TdoToothSelectorDialogComponent,
        LettersRecipientsDialogComponent,
        LettersDeliveryOptionsDialogComponent,
        EditEnumDialogComponent,
        PainHistoryDialogComponent,
        MedicalHistoryDialogComponent,
        PainHistoryComponent,
        PainHistorySleuthWizardDialogComponent,
        MedicalInformationAppointmentDialogComponent,
        PatientHaltDialogComponent,
        CaseEditDialogComponent,
        AllPatientAppointmentsDialogComponent,
        PatientAppointmentDetailDialogComponent,
        ConfirmExplanationDialogComponent,
        ProcedureFormMismatchDialogComponent,
        ReferralPortalComponent,
        FolderSelectionDialogComponent,
        ReferralMatchListComponent,
        SaveLibLecDialogComponent,
        TdoSchedulerComponent,
        EditAppointmentDialogComponent,
      EditAppointmentSelectProcedureDialogComponent




    ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    DirectivesModule,
    NoteExampleModule,
    LandingModule,
    BlankWorkSpaceModule,
    InsuranceModule,
    LoginPageModule,
    PatientModule,
    SchedulingModule,
    PatientPortalModule,
    ARModule,
    CheckInModule,
    TokenHandlerModule,
    PatientLoginModule,
    eRxModule,
    NotificationModule,
    ChartingModule,
    PerioModule,
    LiveChatModule,
    ToothPickerModule,
    FormsFormModule,
    HammerModule,
    TdoControlsModule,
    MatIconModule,
    TdoHeaderModule,
    MainInterfaceModule,
    OfficeCommunicationModule,
    ReportsModule,
    MatRadioModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatSortModule,
    MatTableModule,
    TreatmentModule,
    ReportsModule,
    ImagingModule,
    MatDatepickerModule,
    FinalReportModule,
    MatListModule,
    MatFormFieldModule,
    MatGridListModule,
    MatOptionModule,
    MatSelectModule,
    DragDropModule,
    MatCardModule,
    MatInputModule,
    MatTabsModule,
    MatButtonModule,
    PipeModule,
    TdoMultiselectDropdownModule,
    MatProgressBarModule,
    MtiModule,
    MatAutocompleteModule,
    CommonModule,
    MatTreeModule,
    ReferrerPortalModule,
    ReferrerLoginModule,
    ToastNoAnimationModule.forRoot(),
    DxSchedulerModule,
    // ToastrModule added

    ToastrModule.forRoot(), // ToastrModule added
    TdoPaymentModule,
    MatChipsModule,
    DxDateBoxModule,
    DevExtremeModule,
    MatButtonToggleModule,
    MatMenuModule
  ],
    providers: [
        Globals,
        DatePipe,
        MatDialogModule,
        { provide: MatDialogRef, useValue: {} },
        { provide: APP_INITIALIZER, useFactory: appInitializer, multi: true, deps: [AppInitService] },
        AuthInterceptor,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        AuthGuard,
        ToothService,
        TDOTaskListService,
        FormatPhoneNumberPipe,
        FormatPhonePipe,
        FancyPhonePipe,
        { provide: 'Window',  useValue: window },
        ItemFilterPipe,
        SecureImagePipe
    ],
    exports: [],
    bootstrap: [AppComponent]
})
export class AppModule {
}
